import styled, { keyframes } from 'styled-components';
import { shade } from 'polished';


export const Container = styled.div`
  & {
    position: absolute;
    width: 100%;
    background: #43414a;
    margin-left: -16px;
    margin-top: -13px;
    height: 100%;
    display: flex;
    align-items: center;
  }

  .mobile & {
    position: initial;
    margin-left: 0px;
    margin-top: 0px;
    height: 100vh;
  }

  .mobile & > form {
    padding: 0px;
    
    > div, > button {
      max-width: 80vw;
    }
  }

  & > form {
    width: 400px;
    height: 450px;
    background: #dcdcdc;
    padding: 47px 110px 80px 20px;
    border-radius: 0 100% 100% 0;
    margin: 0;    

    & > img {
      width: 250px;
    }
  }

  .button-wrapper {
    width: 392px;
    display: flex;
    flex-direction: row;
    gap: 8px;
  }
`;

export const Content = styled.div`
  /* display: flex;
  flex-direction: column;
  align-items: center;
  place-content: center;
  width: 100%;
  max-width: 700px; */
`;

const appearFromLeft = keyframes`
  from {
    opacity: 0;
    transform: translateX(-50px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
`;

export const AnimationContainer = styled.div`
  /* display: flex;
  flex-direction: column;
  align-items: center;
  animation: ${appearFromLeft} 1s;
  form {
    margin: 80px 0;
    width: 340px;
    text-align: center;
    h1 {
      margin-bottom: 24px;
    }
    a {
      color: #f4ede8;
      display: block;
      margin-top: 24px;
      text-decoration: none;
      transition: color 0.2s;
      transition: text 0.2s;
      &:hover {
        color: ${shade(0.2, '#f4ede8')};
        text-decoration: underline;
      }
    }
  }
  > a {
    color: #ff9000;
    display: block;
    margin-top: 24px;
    text-decoration: none;
    transition: color 0.2s;
    transition: text 0.2s;
    display: flex;
    align-items: center;
    &:hover {
      color: ${shade(0.2, '#ff9000')};
      text-decoration: underline;
    }
    svg {
      margin-right: 8px;
    }
  } */
`;

